import { MAP_PADDING_CELLS, MAP_IMAGE_PX } from '@common/contracts';
/** The size a level background must be. Fed to ImageDropzone so the wizard and the
 *  properties editor say the same thing. Deliberately without the geometry lecture —
 *  the author needs the number, not the derivation (that lives in contracts.ts). */
export const MAP_BACKGROUND_SIZE = {
    width: MAP_IMAGE_PX,
    height: MAP_IMAGE_PX,
};
/**
 * How to paint a level's background image so the editor shows what the PLAYER
 * will see.
 *
 * The game does not stretch the image across the authored grid: it draws the
 * image at natural size and lays the cells on a fixed pitch over a PADDED grid,
 * leaving MAP_PADDING_CELLS decorative rings around the playable area (see the
 * MAP GEOMETRY block in contracts.ts). So the authored grid covers only the
 * middle of the picture, and the author's A1 is NOT the image's top-left corner.
 *
 * Two shapes, because our surfaces paint the background two different ways:
 *  - backgroundOnGridStyle: the image sits ON the grid element (the pickers) —
 *    scale it up and centre it; the padding is symmetric, so centring puts the
 *    grid exactly where the game puts it.
 *  - backgroundLayerRect: the image is its own absolutely-positioned layer (the
 *    main editor canvas) — gives the layer's offset and span in pixels.
 */
/** Image span as a multiple of the authored grid, e.g. 15/11 for an 11x11 level. */
export function backgroundSpanRatio(gridCells) {
    return (gridCells + MAP_PADDING_CELLS * 2) / gridCells;
}
/** How far the playable grid is inset on the full picture, as a % of the picture —
 *  2 of 15 cells = 13.33%. For surfaces that show the WHOLE map (picture on a stage,
 *  grid positioned on top) rather than only the playable middle. */
export function gridInsetPercent(gridCells) {
    return (MAP_PADDING_CELLS / (gridCells + MAP_PADDING_CELLS * 2)) * 100;
}
/** For a background painted on the grid element itself. */
export function backgroundOnGridStyle(gridCells) {
    const pct = backgroundSpanRatio(gridCells) * 100;
    return {
        backgroundSize: `${pct}% ${pct}%`,
        // Symmetric padding ⇒ centring lands the grid exactly over the middle.
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    };
}
/** For a background drawn as its own layer over a grid of `gridPx` pixels. */
export function backgroundLayerRect(gridCells, cellPx) {
    const padPx = MAP_PADDING_CELLS * cellPx;
    return {
        offsetPx: -padPx,
        spanPx: (gridCells + MAP_PADDING_CELLS * 2) * cellPx,
    };
}
